import { useRef, useState } from 'react';

import { Box, Collapse, Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import ReadMoreButton from '@components/atoms/readMore';

type Props = {
  description: string;
  collapseSize: number;
};

const ProductDetailDescription = ({ description, collapseSize }: Props) => {
  const collapseSizeRef = useRef<any>();
  const [expandDescription, setExpandDescription] = useState(false);
  const { t } = useTranslation('common');
  return (
    <div>
      <div className="course-description-title-desktop">
        <Typography color="black" variant="h4" fontWeight="500" className="course-description-title">
          {t('product_detail.bundle.bundle_detail.titile')}
        </Typography>
        <Box mt={1} mb={2}>
          <Divider />
        </Box>
      </div>

      <Box paddingY="10px" style={{ fontFamily: 'Lanna' }}>
        {collapseSizeRef?.current?.offsetHeight > collapseSize ? (
          <>
            <Collapse in={expandDescription} collapsedSize={collapseSize}>
              <div style={{ marginTop: 20, position: 'relative' }}>
                <div ref={collapseSizeRef} dangerouslySetInnerHTML={{ __html: description! }} />
                {!expandDescription && <Box className="overlay" />}
              </div>
            </Collapse>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <ReadMoreButton
                title_expand={t('expand')}
                title_unexpand={t('unexpand')}
                expand={expandDescription}
                onClick={() => setExpandDescription(!expandDescription)}
                icon={false}
              />
            </Box>
          </>
        ) : (
          <div style={{ marginTop: 20, position: 'relative' }}>
            <div ref={collapseSizeRef} dangerouslySetInnerHTML={{ __html: description! }} />
          </div>
        )}
      </Box>
    </div>
  );
};

export default ProductDetailDescription;
